export default __webpack_public_path__ + "static/media/down-icon.a3dbf90e.svg";